var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4176 28.5H6.21216C3.88514 28.5 2 30.3851 2 32.7122V72.7885C2 75.1155 3.88514 77.0007 6.21216 77.0007H72.5365C74.8635 77.0007 76.7487 75.1155 76.7487 72.7885V32.7122C76.7487 30.3851 74.8635 28.5 72.5365 28.5H61.8257",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0835 63.3442H20.1605C19.6892 63.3442 19.3071 63.7263 19.3071 64.1976V69.2348C19.3071 69.7061 19.6892 70.0882 20.1605 70.0882H59.0835C59.5548 70.0882 59.9369 69.7061 59.9369 69.2348V64.1976C59.9369 63.7263 59.5548 63.3442 59.0835 63.3442Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.451 51.2158H13.3348C12.8635 51.2158 12.4814 51.5979 12.4814 52.0692V57.1854C12.4814 57.6567 12.8635 58.0388 13.3348 58.0388H18.451C18.9223 58.0388 19.3044 57.6567 19.3044 57.1854V52.0692C19.3044 51.5979 18.9223 51.2158 18.451 51.2158Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3153 51.2158H25.1991C24.7278 51.2158 24.3457 51.5979 24.3457 52.0692V57.1854C24.3457 57.6567 24.7278 58.0388 25.1991 58.0388H30.3153C30.7866 58.0388 31.1687 57.6567 31.1687 57.1854V52.0692C31.1687 51.5979 30.7866 51.2158 30.3153 51.2158Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0329 52.3818V57.1859C43.0331 57.2979 43.0113 57.4088 42.9686 57.5123C42.926 57.6158 42.8633 57.7099 42.7842 57.7892C42.7051 57.8685 42.6112 57.9314 42.5078 57.9743C42.4044 58.0172 42.2935 58.0393 42.1815 58.0393H37.0633C36.8375 58.0393 36.6209 57.9496 36.4613 57.7899C36.3016 57.6303 36.2119 57.4137 36.2119 57.1879V52.3839",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0419 51.2158H48.9256C48.4543 51.2158 48.0723 51.5979 48.0723 52.0692V57.1854C48.0723 57.6567 48.4543 58.0388 48.9256 58.0388H54.0419C54.5132 58.0388 54.8952 57.6567 54.8952 57.1854V52.0692C54.8952 51.5979 54.5132 51.2158 54.0419 51.2158Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9061 51.2158H60.7899C60.3186 51.2158 59.9365 51.5979 59.9365 52.0692V57.1854C59.9365 57.6567 60.3186 58.0388 60.7899 58.0388H65.9061C66.3774 58.0388 66.7595 57.6567 66.7595 57.1854V52.0692C66.7595 51.5979 66.3774 51.2158 65.9061 51.2158Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.451 39.0884H13.3348C12.8635 39.0884 12.4814 39.4704 12.4814 39.9418V45.058C12.4814 45.5293 12.8635 45.9114 13.3348 45.9114H18.451C18.9223 45.9114 19.3044 45.5293 19.3044 45.058V39.9418C19.3044 39.4704 18.9223 39.0884 18.451 39.0884Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7714 45.9119H25.1971C25.0851 45.9119 24.9742 45.8899 24.8708 45.8469C24.7674 45.804 24.6734 45.7411 24.5943 45.6619C24.5153 45.5826 24.4526 45.4885 24.4099 45.385C24.3673 45.2815 24.3454 45.1705 24.3457 45.0586V43.2849M54.8971 43.2849V45.0586C54.8971 45.1705 54.875 45.2814 54.8321 45.3848C54.7891 45.4882 54.7263 45.5822 54.647 45.6613C54.5677 45.7404 54.4736 45.803 54.3701 45.8457C54.2666 45.8884 54.1556 45.9102 54.0437 45.9099H51.4714",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9061 39.0884H60.7899C60.3186 39.0884 59.9365 39.4704 59.9365 39.9418V45.058C59.9365 45.5293 60.3186 45.9114 60.7899 45.9114H65.9061C66.3774 45.9114 66.7595 45.5293 66.7595 45.058V39.9418C66.7595 39.4704 66.3774 39.0884 65.9061 39.0884Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1573 39.2527L39.6215 54.9987L19.0878 39.2527C18.5678 38.8549 18.1466 38.3425 17.8569 37.7554C17.5672 37.1683 17.4168 36.5223 17.4175 35.8676V5.41149C17.4175 3.52635 18.9438 2 20.829 2H58.4141C60.2992 2 61.8256 3.52838 61.8256 5.41149V35.8676C61.8256 37.1932 61.2114 38.4439 60.1573 39.2527Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6455 37.4534V11.1021H36.5746C39.6314 11.1037 42.5626 12.3187 44.7241 14.4802C46.8856 16.6417 48.1007 19.5729 48.1023 22.6298V25.9237C48.1007 28.9805 46.8856 31.9117 44.7241 34.0732C42.5626 36.2347 39.6314 37.4498 36.5746 37.4514L30.6455 37.4534Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign2);
export default __webpack_public_path__ + "static/media/design 2.9fa9bb722082457a8ac34d84a5f1b088.svg";
export { ForwardRef as ReactComponent };